import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import "./style.scss";
import Navbar from "../../components/navbar";
import QuestionArrSidebar from "./partials/sidebar";
import QuestionBox from "./partials/questionBox";
import ProgressCircle from "./partials/progress";
import {
  getAssesmentProgress,
  getAssesmentQuestions,
  saveResponse,
  updateStatus,
  updateSubmitStatus,
} from "../../api/apis/assesments";
import { getAssessmentData } from "../../functions/localStorage";
import Loader from "../../components/Loader";
import { roundedNumber } from "../../functions/common";
import ShowSubmit from "./partials/showSubmit";
import Instructions from "./partials/instructions";

const yesNoTypes = ["YN+AL-Text", "YN+Text", "YN", "YN + SC"];

const getScore = ({ answers, questionArre }) => {
  let score = {};
  questionArre?.forEach((v, i) => {
    let categoryScore = 0;
    v?.questionnaire?.forEach((question) => {
      if (answers?.[question?.refCode] && question?.isRequired) {
        const answer = answers?.[question?.refCode];
        const scoringPoints = question?.scoringPoints;
        const answersFromQuestion = question?.answers;
        const weight = Number(scoringPoints?.weight || 1);
        if (question?.responseType === "SC") {
          const splittedAnswer = answer?.split(" + ")?.[0];
          const swappedObject = Object.fromEntries(
            Object.entries(answersFromQuestion).map(([key, value]) => [
              value,
              key,
            ])
          );
          const selectedAnsKey = swappedObject?.[splittedAnswer];
          const points = Number(scoringPoints?.[selectedAnsKey] || 0);
          const finalScore = Number(points) * Number(weight);
          categoryScore += finalScore;
        }
        if (yesNoTypes?.includes(question?.responseType)) {
          const splittedAnswer = answer?.split(" + ")?.[0];
          const points =
            splittedAnswer === "Yes"
              ? scoringPoints?.forYes || 0
              : scoringPoints?.forNo || 0;
          const finalScore = Number(points) * Number(weight);
          categoryScore += finalScore;
        }
      }
    });
    score[`scoreForCategory${i + 1}`] = isNaN(categoryScore)
      ? 0
      : categoryScore;
  });
  score.totalScore = Object.values(score)?.reduce(
    (acc, score) => acc + (score || 0),
    0
  );
  return score;
};

const getCurrentScore = (answer, currentQuestion) => {
  let categoryScore = 0;
  if (currentQuestion?.isRequired) {
    const scoringPoints = currentQuestion?.scoringPoints;
    const answersFromQuestion = currentQuestion?.answers;
    const weight = Number(scoringPoints?.weight || 1);
    if (currentQuestion?.responseType === "SC") {
      const splittedAnswer = answer?.split(" + ")?.[0];
      const swappedObject = Object.fromEntries(
        Object.entries(answersFromQuestion).map(([key, value]) => [value, key])
      );
      const selectedAnsKey = swappedObject?.[splittedAnswer];
      const points = Number(scoringPoints?.[selectedAnsKey] || 0);
      const finalScore = Number(points) * Number(weight);
      categoryScore += finalScore;
    }
    if (yesNoTypes?.includes(currentQuestion?.responseType)) {
      const splittedAnswer = answer?.split(" + ")?.[0];
      const points =
        splittedAnswer === "Yes"
          ? scoringPoints?.forYes || 0
          : scoringPoints?.forNo || 0;
      const finalScore = Number(points) * Number(weight);
      categoryScore += finalScore;
    }
  }
  return categoryScore;
};

const QuestionsNew = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const assesmentAndLocation = getAssessmentData();
  const [loading, setLoading] = useState(false);
  const [questionArr, setQuestionArre] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answersDone, setAnswersDone] = useState({});
  const [remainingQuestions, setRemainingQuestions] = useState([]);
  const [requiredQuestions, setRequiredQuestions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(
    assesmentAndLocation?.submissionStatus === "submitted"
  );
  const [showSubmit, setShowSubmit] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true);
  const [alertRequired, setAlertRequired] = useState(false);
  const questionSectionRef = useRef();

  const parsedQuestions =
    questionArr
      ?.map((v) =>
        v?.questionnaire?.map((data) => ({
          ...data,
          heading: v?.title,
          categoryDescription: v?.categoryDescription,
        }))
      )
      .flat()
      ?.filter((v) => v?.responseType) ?? [];
  const selectedQues = parsedQuestions?.[currentIndex]?.refCode;
  const totalQuestions = parsedQuestions?.length ?? 0;
  const currentQuestion =
    parsedQuestions?.find((v, ind) => ind === currentIndex) ?? {};
  const selectQuestion = (numb) => {
    setCurrentIndex(numb);
    setOpenDrawer(false);
    setShowSubmit(false);
    setShowInstructions(false);
    setUploadLoading(false);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };
  const [uploadLoading, setUploadLoading] = useState(false);
  const requiredAnswersDone = {};
  // eslint-disable-next-line array-callback-return
  Object.keys(answersDone).map((item) => {
    const selectedQues = parsedQuestions?.find((v) => v?.refCode === item);
    if (selectedQues?.isRequired) {
      requiredAnswersDone[item] = answersDone[item];
    }
  });
  const completePercentage = roundedNumber(
    (Object?.keys(requiredAnswersDone)?.length / requiredQuestions?.length) *
    100
  );
  const isLastQuestion = currentIndex === totalQuestions - 1;
  const isAllRequiredFilled = requiredQuestions?.every(
    (v) => requiredAnswersDone?.[v]
  );

  const handleAnswer = (answer) => {
    setAnswers((prev) => ({
      ...prev,
      [String(currentQuestion?.refCode)]: answer,
    }));
  };

  const handleMultiQuesAnswer = (subId, answer) => {
    setAnswers((prev) => ({
      ...prev,
      [currentQuestion.id]: {
        ...prev[currentQuestion.id],
        [subId]: answer,
      },
    }));
  };

  const handleNext = useCallback(
    (skip, nextSkipped, status) => {
      if (nextSkipped) {
        const filteredRemaining = remainingQuestions?.filter(
          (v) => !Object.keys(answersDone)?.includes(v)
        );
        const getIndexes = filteredRemaining?.map((v) => {
          return parsedQuestions?.findIndex((q) => q?.refCode === v);
        });
        let ind = getIndexes?.find((v) => v > currentIndex);
        if (currentIndex >= getIndexes?.[getIndexes?.length - 1]) {
          ind = getIndexes?.[0];
        }
        setCurrentIndex(ind);
      } else {
        if (currentIndex < totalQuestions - 1) {
          setCurrentIndex((prev) => prev + 1);
        }
      }
      setUploadLoading(false);
      setLoading(true);

      if (!skip) {
        const responses = {
          responses: {
            [currentQuestion?.refCode]: answers[currentQuestion?.refCode],
          },
          scores: {
            [currentQuestion?.refCode]: getCurrentScore(
              answers[currentQuestion?.refCode],
              currentQuestion
            ),
          },
        };
        console.log("Answers done",answersDone)
        if (Object.keys(answersDone)?.length === 0) {
          updateStatus(assesmentAndLocation?.assessmentId, { status: "draft" });
        }
        status !== "COMPLETED" &&
          saveResponse(assesmentAndLocation?.assessmentId, responses);
        setAnswersDone((prev) => ({
          ...prev,
          [currentQuestion?.refCode]: answers[currentQuestion?.refCode],
        }));
      }
      if (isLastQuestion) {
        setShowSubmit(true);
        setAlertRequired(true);
        submitUpdate();
      }
      if (status === "COMPLETED") {
        updateStatus(assesmentAndLocation?.assessmentId, {
          status: "submitted",
          scores: getScore({
            answers: {
              ...answersDone,
              [currentQuestion?.refCode]: answers[currentQuestion?.refCode],
            },
            questionArre: questionArr,
          }),
        });
        setIsSubmitted(true);
      }

      setLoading(false);
    },
    [currentIndex, totalQuestions, answers]
  );

  const submitUpdate = () => {
    updateSubmitStatus(assesmentAndLocation?.assessmentId, {
      is_submit_assessment_page_triggered: true,
    });
  };

  const getQuestionAndResponses = async () => {
    setLoading(true);
    try {
      const [questionsResponse, userResponses] = await Promise.all([
        getAssesmentQuestions(assesmentAndLocation?.assessmentId),
        getAssesmentProgress(assesmentAndLocation?.assessmentId),
      ]);
      setQuestionArre(questionsResponse?.data ?? []);
      const userProgress = userResponses?.data?.data?.progress ?? {};
      const userResponsesData = userResponses?.data?.data?.responses ?? {};
      const parsedQuestions =
        questionsResponse?.data
          ?.map((v) =>
            v?.questionnaire?.map((data) => ({
              ...data,
              heading: v?.title,
              categoryDescription: v?.categoryDescription,
            }))
          )
          .flat()
          ?.filter((v) => v?.responseType) ?? [];
      const currentQuesIndex =
        parsedQuestions?.findIndex(
          (v) => v?.refCode === userProgress?.nextQuestionRef
        ) ?? 0;
      setCurrentIndex(currentQuesIndex < 0 ? 0 : currentQuesIndex);
      setAnswers(userResponsesData ?? {});
      setAnswersDone(userResponsesData ?? {});
      setRemainingQuestions(userProgress?.remainingQuestionRefs);
      setRequiredQuestions(userProgress?.requiredQuestionsRefs);
      setLoading(false);
      setShowInstructions(false);
      setAlertRequired(userResponses?.data?.data?.assessment?.is_submit_assessment_page_triggered ?? false)
    } catch (error) {
      console.error("Error initializing questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const nextDisabled = () => {
    const firstRequiredTypes = ["YN+AL-Text", "SC", "Text", "YN"];
    if (currentQuestion?.refCode === "1.10") {
      const splittedAnswers = answers[currentQuestion?.refCode]?.split(" + ");
      if (!splittedAnswers?.[0]) {
        return true;
      } else if (splittedAnswers?.[0] === "No" && !splittedAnswers?.[1]) {
        return true;
      }
      return false;
    } else if (currentQuestion?.responseType === "NPS") {
      const splittedAnswers = answers[currentQuestion?.refCode]?.split(" + ");
      return !Number(splittedAnswers?.[0]) || isNaN(splittedAnswers?.[0]);
    } else if (currentQuestion?.responseType === "SC-UNIT+TEXT") {
      const splittedAnswers = answers[currentQuestion?.refCode]?.split(" + ");
      return !splittedAnswers?.every((v) => v !== "");
    } else if (firstRequiredTypes?.includes(currentQuestion?.responseType)) {
      const splittedAnswers = answers[currentQuestion?.refCode]?.split(" + ");
      return !splittedAnswers?.[0];
    } else if (currentQuestion?.responseType === "NUM") {
      const splittedAnswers = answers[currentQuestion?.refCode]?.split(" + ");
      return !Number(splittedAnswers?.[0]) || isNaN(splittedAnswers?.[0]);
    } else {
      return !answers[currentQuestion?.refCode];
    }
  };
  useEffect(() => {
    if (assesmentAndLocation?.submissionStatus !== "submitted") {
      getQuestionAndResponses();
    }
  }, []);

  const checkUnAnswered = () => {
    setShowSubmit(true);
    setAlertRequired(true);
    setShowInstructions(false);
    submitUpdate();
  };

  useLayoutEffect(() => {
    if (questionSectionRef?.current) {
      setTimeout(() => {
        questionSectionRef?.current?.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      }, 1);
    }
  }, [questionSectionRef?.current, showInstructions, showSubmit, currentIndex]);
  console.log("Current question,curre",currentQuestion)
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="question__screen">
          <Navbar
            hamburger
            handleOpenDrawer={handleOpenDrawer}
            showLocationBtn
          />
          <div className="hr__line"></div>
          <div className="questions__section__new__main">
            <QuestionArrSidebar
              setOpenDrawer={setOpenDrawer}
              openDrawer={openDrawer}
              selectQuestion={selectQuestion}
              selectedQues={selectedQues}
              questionArr={questionArr}
              answersDone={answersDone}
              parsedQuestions={parsedQuestions}
              checkUnAnswered={checkUnAnswered}
              showSubmit={showSubmit}
              setShowInstructions={setShowInstructions}
              showInstructions={showInstructions}
              isSubmitted={isSubmitted}
              setAlertRequired={setAlertRequired}
              alertRequired={alertRequired}
            />
            <div ref={questionSectionRef} className="question__section">
              <div className="question__header">
                <div className="col-7">
                  <h2>{assesmentAndLocation?.address ?? ""}</h2>
                </div>
                <div className="col-5 d-flex justify-content-end">
                  <ProgressCircle completePercentage={completePercentage} />
                </div>
              </div>
              {showInstructions ? (
                <Instructions
                  getQuestionAndResponses={getQuestionAndResponses}
                />
              ) : showSubmit || isSubmitted ? (
                <ShowSubmit
                  assesmentAndLocation={assesmentAndLocation}
                  isSubmitted={isSubmitted}
                  selectQuestion={selectQuestion}
                  parsedQuestions={parsedQuestions}
                  answersDone={answersDone}
                  requiredQuestions={requiredQuestions}
                  handleNext={handleNext}
                  setShowInstructions={setShowInstructions}
                />
              ) : (
                <div className="question__details">
                  <div className="question__details__head">
                    <h3>{currentQuestion?.heading}</h3>
                    <br />
                    <p>{currentQuestion?.categoryDescription ?? ""}</p>
                  </div>
                  <QuestionBox
                    currentQuestion={currentQuestion}
                    answers={answers}
                    handleAnswer={handleAnswer}
                    uploadLoading={uploadLoading}
                    setUploadLoading={setUploadLoading}
                    handleMultiQuesAnswer={handleMultiQuesAnswer}
                    loading={loading}
                    handleNext={handleNext}
                    nextDisabled={nextDisabled()}
                    isLastQuestion={isLastQuestion}
                    isAllRequiredFilled={isAllRequiredFilled}
                    requiredAnswersDone={requiredAnswersDone}
                    requiredQuestions={requiredQuestions}
                    answersDone={answersDone}
                    currentIndex={currentIndex}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionsNew;
